(() => {
  const root = document.querySelector('#instame-in-store-ipad');
  if (!root) return;
  const content = root.querySelector('[data-station-content]');
  const phoneMode = root.dataset.orderMode === 'phone';
  const contactRequired = root.dataset.contactRequired === 'true';
  const contactKey = 'instame_in_store_customer_contact';
  const stationNumber = root.dataset.stationNumber || '1';
  const entryParams = new URLSearchParams(location.search);
  let pendingProduct = entryParams.get('product');
  if(pendingProduct && /^\/products\/[a-z0-9-]+$/.test(pendingProduct)) {
    const variant=entryParams.get('variant');
    if(/^\d+$/.test(variant || ''))pendingProduct+='?variant='+variant;
  } else pendingProduct=null;
  let pendingCart = location.hash === '#cart';
  let currentScreen = 'welcome';
  let contactDraft = null;
  function setScreen(screen) {
    currentScreen = screen;
    const back = root.querySelector('[data-station-back]');
    // A 'placed' receipt keeps the shopper's photos, so Back stays available.
    if(back)back.disabled = screen === 'welcome' || screen === 'receipt';
    resetButton.hidden = phoneMode || !session || screen === 'welcome' || screen === 'receipt';
    cartButton.hidden = false;
  }
  const wizardHost = root.querySelector('[data-wizard-host]');
  const resetButton = root.querySelector('[data-station-reset]');
  const cartButton = root.querySelector('[data-station-cart]');
  const cartIcon = cartButton.querySelector?.('svg')?.outerHTML || '<svg viewBox="0 0 20 20" fill="none" aria-hidden="true"><path d="M4 7h12v10H4zM7 7V5a3 3 0 0 1 6 0v2" stroke="currentColor" stroke-width="1.5"/></svg>';
  const savedPets = root.querySelector('[data-saved-pets]');
  // Lets staff tell the four iPads apart at a glance on the welcome screen.
  const stationEmoji = { 1: '❤️', 2: '⭐', 3: '😊', 4: '🌷' };
  const deviceSessionKey = `instame_station_${stationNumber}_device_session`;
  const startPendingKey = `instame_station_${stationNumber}_start_pending`;
  const checkoutKey = `instame_station_${stationNumber}_checkout_started`;
  const selectionsKey = `instame_station_${stationNumber}_selections`;
  const designOptionsKey = `instame_station_${stationNumber}_design_options`;
  const lastActivityKey = `instame_station_${stationNumber}_last_activity`;
  const resetPendingKey = `instame_station_${stationNumber}_reset_pending`;
  const phoneTokenKey = 'instame_in_store_phone_token';
  const phoneSessionKey = 'instame_in_store_phone_session';
  const phoneUploadsKey = 'instame_in_store_phone_uploads';
  const phoneReceiptKey = 'instame_in_store_phone_receipt';
  const api = root.dataset.backendUrl || window.InstaMePhotoUpload?.getBackendUrl();
  let session = null;
  // The iPad needs no key: its station number and its own session id are enough.
  window.instameInStoreRequestHeaders = () => {
    if (!session) throw new Error('This design session is unavailable.');
    if (!phoneMode) return { 'X-InstaMe-Session': session.session_id, 'X-InstaMe-Station':stationNumber };
    const token = sessionStorage.getItem(phoneTokenKey);
    if (!token) throw new Error('This design session is unavailable.');
    return { Authorization: `Bearer ${token}` };
  };
  let wizard = null;
  let catalogMarkup = null;
  let catalogNode = null;
  const productPages = new Map();
  const productPageRequests = new Map();
  let catalogType = '';
  let shipOnlyProductIds = new Set();
  let uploads = [];
  let selections = [];
  let photoNames = new Map();
  let slot = 0;
  let polling = null;
  let pollInFlight = false;
  let pollGeneration = 0;
  let handoffOpen = false;
  let busy = false;
  let lastActivityAt = Number(localStorage.getItem(lastActivityKey)) || Date.now();
  let lastTouchAt = Date.now();
  let orderEpoch = 0;
  let recoveryScreen = false;
  let handoffTimer = null;
  let phoneThumbUrls = [];
  let phoneSelectedFiles = [];
  const handoffHeartbeatMs = 30 * 1000;
  const handoffLeaseMs = 90 * 1000;

  const esc = value => String(value ?? '').replace(/[&<>"']/g, c =>
    ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]);
  const button = (label, action, primary = false) =>
    `<button type="button" class="in-store-ipad__button${primary ? ' in-store-ipad__button--primary' : ''}" data-action="${action}">${label}</button>`;
  const actions = (...items) => `<div class="in-store-ipad__actions">${items.join('')}</div>`;
  const status = (value, error = false) =>
    `<p class="in-store-ipad__status" data-error="${error}">${esc(value)}</p>`;
  function newStartSessionId() {
    if (!window.crypto?.getRandomValues) throw new Error('This iPad cannot start a secure order. Ask a LilaLand team member for help.');
    const bytes = window.crypto.getRandomValues(new Uint8Array(16));
    bytes[6] = (bytes[6] & 0x0f) | 0x40;
    bytes[8] = (bytes[8] & 0x3f) | 0x80;
    const hex = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
    return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(16, 20)}-${hex.slice(20)}`;
  }
  function renderSavedPets() {
    // This legacy header control is deliberately hidden. Do not rebuild photo
    // thumbnails on every keystroke or trigger image observers for hidden UI.
    if (!savedPets) return;
    savedPets.hidden = true;
  }
  function themePath(path) {
    const url = new URL(path, location.origin);
    const previewTheme = new URLSearchParams(location.search).get('preview_theme_id');
    if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
    return url.pathname + url.search;
  }

  async function stationRequest(method, body) {
    if (phoneMode) {
      if (method === 'GET') return { active: Boolean(session), ...session, uploads };
      if (body?.action === 'start' || body?.action === 'next-order') {
        const continuing = body.action === 'next-order';
        const token = continuing && sessionStorage.getItem(phoneTokenKey);
        if (continuing && !token) throw new Error('This phone session is unavailable.');
        const response = await fetch(`${api}/api/in-store/phone-session`, { method: 'POST',
          ...(continuing ? { headers: { Authorization: `Bearer ${token}` } } : {}) });
        const data = await response.json().catch(() => null);
        if (!response.ok || !data?.token || !data?.session_id || !data?.user_id) {
          throw new Error(data?.error || 'Could not start phone ordering. Try again.');
        }
        if (continuing && (data.user_id !== session?.user_id || data.session_id === session?.session_id)) {
          throw new Error('Could not continue this design session. Try again.');
        }
        sessionStorage.setItem(phoneTokenKey, data.token);
        sessionStorage.setItem(phoneSessionKey, JSON.stringify({
          session_id: data.session_id, user_id: data.user_id, expires_at: data.expires_at,
        }));
        return { active: true, session_id: data.session_id, user_id: data.user_id };
      }
      if (body?.action === 'end') return { ended: true };
      return { active: Boolean(session), ...session };
    }
    if (!api) throw new Error('The station is unavailable.');
    const sessionProof = session?.session_id || localStorage.getItem(deviceSessionKey) ||
      sessionStorage.getItem('instame_session_id');
    let response;
    try {
      response = await fetch(`${api}/api/in-store/station?station=${stationNumber}`, {
        method,
        cache: 'no-store',
        headers: {
          'X-InstaMe-Station':stationNumber,
          ...(sessionProof ? { 'X-InstaMe-Session': sessionProof } : {}),
          ...(body ? { 'Content-Type': 'application/json' } : {}),
        },
        ...(body ? { body: JSON.stringify(body) } : {}),
      });
    } catch {
      throw new Error('Could not connect. Check the Internet connection and try again.');
    }
    const data = await response.json().catch(() => null);
    if (!response.ok) {
      const error = new Error(data?.error || 'The station is unavailable.');
      error.status = response.status;
      throw error;
    }
    if (!data || typeof data !== 'object') throw new Error('The station did not respond. Try again.');
    return data;
  }
  const stationAction = (action, extra = {}) => stationRequest('POST', {
    action, session_id: session?.session_id, ...extra,
  });

  function setIdentity() {
    if (!session) return;
    if (!phoneMode) localStorage.setItem(deviceSessionKey, session.session_id);
    localStorage.setItem('instame_user_id', session.user_id);
    sessionStorage.setItem('instame_session_id', session.session_id);
    window.instameUserId = session.user_id;
    window.instameSessionId = session.session_id;
    window.__instamePopupSession = true;
    window.__instameInStoreSession = true;
  }

  function savePhoneUploads() {
    if (phoneMode) sessionStorage.setItem(phoneUploadsKey, JSON.stringify(uploads));
  }

  function clearBrowserOrderData() {
    contactDraft = null;
    sessionStorage.clear();
    for (let index = localStorage.length - 1; index >= 0; index--) {
      const key = localStorage.key(index);
      if (key?.startsWith('instame_') && key !== resetPendingKey &&
          key!=='instame_station_number') localStorage.removeItem(key);
    }
    window.__instameInStoreSession = false;
    window.__instamePopupSession = false;
    window.__instamePopupOrigin = null;
    window.instameUserId = null;
    window.instameSessionId = null;
  }

  function customerContact() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(contactKey) || 'null');
      return saved?.session_id === session?.session_id ? saved.customer : null;
    } catch { return null; }
  }

  function showCustomerDetails(error = '', entered = null) {
    hideNativeWizard();
    stopPolling();
    setScreen('contact');
    entered ||= contactDraft;
    const customer = entered || customerContact() || {};
    let savedMarketing = true;
    try {
      const saved = JSON.parse(sessionStorage.getItem(contactKey) || 'null');
      if (saved?.session_id === session?.session_id) savedMarketing = saved.marketing !== false;
    } catch {}
    content.innerHTML = `<div class="in-store-ipad__eyebrow">Your order</div>
      <h1>How can our team find your order?</h1>
      <p>Enter your name and phone number so our team can identify your order at the counter.</p>
      <label class="in-store-ipad__field">Your name
        <input data-customer-name autocomplete="name" maxlength="100" value="${esc(customer.name || '')}" required></label>
      <label class="in-store-ipad__field">Phone number
        <input data-customer-phone type="tel" inputmode="numeric" pattern="[0-9]*" autocomplete="tel-national" maxlength="14" value="${esc((customer.phone || '').replace(/^\+1(?=\d{10}$)/, ''))}" required></label>
      <label class="in-store-ipad__marketing"><input data-customer-marketing type="checkbox" ${(entered ? entered.marketing !== false : savedMarketing) ? 'checked' : ''}> Receive marketing messages</label>
      <p class="in-store-ipad__marketing-note">Optional LilaLand marketing texts. Uncheck to opt out. Confirm by text to subscribe. Consent is not required to buy. Message frequency varies; message and data rates may apply. Reply STOP to unsubscribe.</p>
      ${error ? status(error, true) : ''}${actions(button('Finish', 'customer-continue', true))}`;
  }

  async function saveCustomerDetails() {
    const name = content.querySelector('[data-customer-name]')?.value.trim().replace(/\s+/g, ' ') || '';
    const rawPhone = content.querySelector('[data-customer-phone]')?.value.trim() || '';
    const marketing = content.querySelector('[data-customer-marketing]')?.checked === true;
    const digits = rawPhone.replace(/[\s().-]/g, '').replace(/^\+?1(?=\d{10}$)/, '');
    const phone = '+1' + digits;
    if (!name || name.length > 100 || /[\u0000-\u001f\u007f]/.test(name)) return showCustomerDetails('Enter your name.', { name, phone: rawPhone, marketing });
    if (!/^[2-9]\d{2}[2-9]\d{6}$/.test(digits)) return showCustomerDetails('Enter a valid 10-digit US or Canadian phone number.', { name, phone: rawPhone, marketing });
    const customer = { name, phone };
    contactDraft = null;
    sessionStorage.setItem(contactKey, JSON.stringify({ session_id: session.session_id, customer, marketing }));
    // Keep marketing independent from order creation; never lose the order if
    // Klaviyo is unavailable, and never pass marketing data as Shopify contact.
    const contactSync = contactRequired && window.instameInStoreSaveContact
      ? window.instameInStoreSaveContact({ api, headers: window.instameInStoreRequestHeaders(), customer, marketing })
        .catch(() => { console.warn('Hillsdale contact sync failed; order contact is retained.'); })
      : null;
    void contactSync;
    await finishAtCounter(content.querySelector('[data-action="customer-continue"]'));
  }

  function saveSelections() {
    if (session) sessionStorage.setItem(selectionsKey, JSON.stringify({
      session_id: session.session_id,
      selections,
      photo_names: [...photoNames],
    }));
    renderSavedPets();
  }

  function restoreSelections() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(selectionsKey) || 'null');
      if (saved?.session_id === session?.session_id && Array.isArray(saved.selections)) {
        selections = saved.selections.map(choice => choice && typeof choice.upload_id === 'string'
          ? { upload_id: choice.upload_id, name: String(choice.name || '') } : null);
        photoNames = new Map(Array.isArray(saved.photo_names) ? saved.photo_names
          .filter(item => Array.isArray(item) && typeof item[0] === 'string' && typeof item[1] === 'string') : []);
      }
    } catch { /* A broken browser value must not block the order. */ }
    if (!selections.length && uploads.length) {
      selections = [{ upload_id: uploads[0].upload_id, name: uploads[0].pet_name || '' }];
    }
    selections.forEach(choice => { if (choice?.name) photoNames.set(choice.upload_id, choice.name); });
  }

  function showStationInUse(error = '') {
    hideNativeWizard();
    closePhotoModal();
    recoveryScreen = true;
    orderEpoch++;
    stopPolling();
    session = null;
    wizard = null;
    uploads = [];
    selections = [];
    photoNames = new Map();
    wizardHost.replaceChildren();
    clearBrowserOrderData();
    renderSavedPets();
    resetButton.hidden = true;
    cartButton.hidden = !phoneMode;
    content.innerHTML = `<div class="in-store-ipad__staff"><h1>${contactRequired ? 'An order is already open' : 'Station 1 is in use'}</h1>
      <p>${contactRequired ? 'Continue in the original browser, or start a new order here.' : 'Use the original iPad to finish that order. Ask a LilaLand team member for help if it is unavailable.'}</p>
      ${error ? status(error, true) : ''}
      ${actions(button('Try Again', 'retry-station', true), button('Recover Station', 'recover-station'))}
      ${contactRequired ? actions(button('Start New Order Here', 'restart-station')) : ''}</div>`;
  }

  async function recoverAbandoned(explicitRestart = false) {
    if (busy) return;
    busy = true;
    let released = false;
    try {
      const result = await stationRequest('POST', { action: explicitRestart ? 'restart-station' : 'reset-abandoned' });
      if (!result.ended) throw new Error('This station could not be reset. Try again.');
      released = true;
      await clearCart();
      clearBrowserOrderData();
      showWelcome();
    } catch (error) {
      if (released) {
        content.innerHTML = `<div class="in-store-ipad__staff"><h1>Finish clearing this iPad</h1>
          ${status(error.message, true)}${actions(button('Try Again', 'recover-station', true))}</div>`;
      } else showStationInUse(error.message);
    }
    finally { busy = false; }
  }

  // The server ends an idle order on its own. Retrying can never bring it
  // back, so offer a clean restart instead of a Try Again that loops.
  function showSessionExpired() {
    hideNativeWizard();
    closePhotoModal();
    recoveryScreen = true;
    stopPolling();
    resetButton.hidden = true;
    cartButton.hidden = true;
    content.innerHTML = `<div class="in-store-ipad__staff"><h1>This order timed out</h1>
      <p>Your session expired after a while without activity. Start a new order to try again.</p>
      ${actions(button('Start New Order', 'reset', true))}</div>`;
  }

  function showReconnect(error) {
    hideNativeWizard();
    closePhotoModal();
    recoveryScreen = true;
    stopPolling();
    resetButton.hidden = true;
    content.innerHTML = `<div class="in-store-ipad__staff"><h1>Reconnect to this order</h1>
      ${status(error, true)}${actions(button('Try Again', 'retry-station', true))}</div>`;
  }

  function showWelcome(error = '') {
    hideNativeWizard();
    recoveryScreen = false;
    stopPolling();
    resetButton.hidden = true;
    cartButton.hidden = !phoneMode;
    setScreen('welcome');
    renderSavedPets();
    content.innerHTML = `<div class="in-store-ipad__welcome">
      <div class="in-store-ipad__welcome-copy"><div class="in-store-ipad__eyebrow">Made by the LilaLand team${phoneMode ? '' : ` · Station ${esc(stationNumber)} ${stationEmoji[stationNumber] || ''}`}</div>
      <h1>Your pet, made personal</h1>
      <p>Choose a product, ${phoneMode ? 'upload a pet photo' : 'send a pet photo'}, and see your design before you visit the counter.</p>
      ${actions(button('Start Personalizing', 'start', true))}${error ? status(error, true) : ''}</div>
      <div class="in-store-ipad__welcome-example">
        <figure><img src="${esc(root.dataset.welcomePetUrl)}" alt="Example pet photo"><figcaption>Pet photo</figcaption></figure>
        <span aria-hidden="true" class="in-store-ipad__welcome-arrow">→</span>
        <figure><img src="${esc(root.dataset.welcomeProductUrl)}" alt="Personalized mug made from the example pet photo"><figcaption>Finished mug</figcaption></figure>
      </div></div>`;
  }

  function loadCatalogMarkup() {
    if (catalogMarkup) return Promise.resolve(catalogMarkup);
    const source = root.querySelector('[data-in-store-catalog]');
    if (!source?.content.querySelector('.in-store-ipad__catalog-item product-card a[href*="/products/"]')) {
      return Promise.reject(new Error('No in-store products are available right now. Ask a LilaLand team member for help.'));
    }
    shipOnlyProductIds = new Set([...(source.content.querySelectorAll?.('[data-ship-only="true"]') || [])]
      .map(card => card.dataset.productId));
    // The parser has already moved declarative swatch markup into shadow roots.
    // innerHTML alone drops those roots, breaking the original card controls.
    const copy = source.content.cloneNode(true);
    const originalLists = source.content.querySelectorAll('overflow-list');
    copy.querySelectorAll('overflow-list').forEach((list, index) => {
      const shadow = originalLists[index]?.shadowRoot;
      if (!shadow) return;
      const template = document.createElement('template');
      template.setAttribute('shadowrootmode', 'open');
      template.innerHTML = shadow.innerHTML;
      list.prepend(template);
    });
    const wrapper = document.createElement('div');
    wrapper.append(copy);
    catalogMarkup = wrapper.innerHTML.replaceAll(' (Booth)', '');
    return Promise.resolve(catalogMarkup);
  }

  function showCatalogError(error) {
    hideNativeWizard();
    closePhotoModal();
    recoveryScreen = true;
    content.innerHTML = `<h1>Could not continue this order</h1>${status(error.message, true)}
      ${actions(button('Try Again', 'catalog', true), button('Start Over', 'reset'))}`;
  }

  async function clearCart() {
    const cleared = await fetch('/cart/clear.js', { method: 'POST' });
    if (!cleared.ok) throw new Error('Could not clear the previous cart. Ask a LilaLand team member for help.');
    // Shopify's clear endpoint leaves the cart note and attributes in place.
    const details = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ note: '', attributes: { _popup_event: '' }, discount: '' }),
    });
    if (!details.ok) throw new Error('Could not clear the previous cart details. Ask a LilaLand team member for help.');
    renderCartCount(0);
  }

  async function beginOrder() {
    if (busy) return;
    if (phoneMode && completedPhoneOrder()) return makeAnotherOrder();
    if (session && !recoveryScreen) return showCatalog();
    if (phoneMode) return beginPhoneOrder();
    if (handoffTimer) clearTimeout(handoffTimer);
    if (localStorage.getItem(deviceSessionKey) || localStorage.getItem(startPendingKey)) return resume();
    busy = true;
    orderEpoch++;
    const startButton = content.querySelector('[data-action="start"]');
    if (startButton) { startButton.disabled = true;  }
    try {
      clearBrowserOrderData();
      await clearCart();
      cartButton.hidden = !phoneMode;
      const startId = newStartSessionId();
      localStorage.setItem(deviceSessionKey, startId);
      localStorage.setItem(startPendingKey, startId);
      lastActivityAt = Date.now();
      localStorage.setItem(lastActivityKey, String(lastActivityAt));
      session = await stationAction('start', { start_session_id: startId });
      localStorage.removeItem(startPendingKey);
      lastTouchAt = Date.now();
      uploads = [];
      selections = [];
      photoNames = new Map();
      catalogType = '';
      renderSavedPets();
      wizard = null;
      wizardHost.replaceChildren();
      setIdentity();
      resetButton.hidden = false;
      await showCatalog();
    } catch (error) {
      if (error.status === 409) showStationInUse();
      else if (session) showCatalogError(error);
      else if (localStorage.getItem(startPendingKey)) showReconnect(error.message);
      else showWelcome(error.message);
    }
    finally { busy = false; }
  }

  async function beginPhoneOrder() {
    busy = true;
    orderEpoch++;
    if (handoffTimer) clearTimeout(handoffTimer);
    const startButton = content.querySelector('[data-action="start"]');
    if (startButton) { startButton.disabled = true;  }
    try {
      clearBrowserOrderData();
      await clearCart();
      session = await stationAction('start');
      uploads = [];
      selections = [];
      photoNames = new Map();
      catalogType = '';
      wizard = null;
      wizardHost.replaceChildren();
      setIdentity();
      resetButton.hidden = false;
      await showCatalog();
    } catch (error) { showWelcome(error.message); }
    finally { busy = false; }
  }

  async function endOrder() {
    if (busy) return;
    if (phoneMode) return endPhoneOrder();
    if (handoffTimer) clearTimeout(handoffTimer);
    busy = true;
    orderEpoch++;
    // Keep a reset marker until both the backend session and Shopify cart are
    // cleared. A reload in the middle must not restore the old shopper's photos.
    localStorage.setItem(resetPendingKey, session?.session_id || 'none');
    stopPolling();
    wizard?.instantPreview?.closePopup?.();
    document.querySelector('[data-preview-popup]')?.remove();
    resetButton.disabled = true;

    let resetError = null;
    try { if (session) await stationAction('end'); }
    catch (error) { resetError = error; }
    try { await clearCart(); }
    catch (error) { resetError ||= error; }
    if (resetError) {
      uploads = [];
      selections = [];
      photoNames = new Map();
      renderSavedPets();
      wizard = null;
      handoffOpen = false;
      clearBrowserOrderData();
      wizardHost.replaceChildren();
      content.innerHTML = `<h1>Ask a LilaLand team member for help</h1>
        ${status('The previous order could not be cleared. Try again before handing this iPad to another shopper.', true)}
        ${actions(button('Try Again', 'reset', true))}`;
      busy = false;
      resetButton.disabled = false;
      resetButton.textContent = 'Start Over';
      return;
    }
    session = null;
    uploads = [];
    selections = [];
    photoNames = new Map();
    catalogType = '';
    renderSavedPets();
    wizard = null;
    handoffOpen = false;
    wizardHost.replaceChildren();
    clearBrowserOrderData();
    localStorage.removeItem(resetPendingKey);
    cartButton.hidden = !phoneMode;
    showWelcome();
    busy = false;
    resetButton.disabled = false;
    resetButton.textContent = 'Start Over';
  }

  async function endPhoneOrder() {
    busy = true;
    orderEpoch++;
    if (handoffTimer) clearTimeout(handoffTimer);
    stopPolling();
    wizard?.instantPreview?.closePopup?.();
    document.querySelector('[data-preview-popup]')?.remove();
    try {
      await clearCart();
      session = null;
      uploads = [];
      selections = [];
      photoNames = new Map();
      wizard = null;
      wizardHost.replaceChildren();
      clearBrowserOrderData();
      cartButton.hidden = !phoneMode;
      showWelcome();
    } catch (error) {
      content.innerHTML = `<h1>Could not start a new order</h1>${status(error.message, true)}
        ${actions(button('Try Again', 'reset', true))}`;
    } finally { busy = false; }
  }

  async function showCatalog() {
    hideNativeWizard();
    const epoch = orderEpoch;
    stopPolling();
    await closeHandoff();
    if (epoch !== orderEpoch || !session) return;
    recoveryScreen = false;
    await loadCatalogMarkup();
    if (epoch !== orderEpoch || !session) return;
    resetButton.hidden = false;
    setScreen('catalog');
    if (catalogNode) {
      // Keep the native cards, swatches and loaded images when returning from
      // a product or cart instead of parsing the entire catalogue again.
      content.innerHTML = '<h1>Choose a design</h1>';
      content.append(catalogNode);
      refreshCartButton();
      filterCatalog(catalogType);
      return;
    }
    content.innerHTML = `<h1>Choose a design</h1><div class="in-store-ipad__catalog" data-catalog></div>`;
    const catalog = content.querySelector('[data-catalog]');
    if (!catalog) return;
    catalogNode = catalog;
    catalog.innerHTML = catalogMarkup;
    refreshCartButton();
    const types = new Set([...catalog.querySelectorAll('[data-catalog-type]')].map(item => item.dataset.catalogType));
    const labels = { mug: 'Mugs', portrait: 'Portraits', magnet: 'Magnets', ornament: 'Ornaments', keychain: 'Keychains', coaster: 'Coasters', 'phone case': 'Phone Cases', blanket: 'Blankets' };
    const order = ['mug', 'portrait', 'ornament', 'coaster', 'magnet', 'keychain', 'phone case', 'blanket'];
    const rank = type => (order.indexOf(type) < 0 ? 99 : order.indexOf(type));
    const sorted = [...types].sort((a, b) => rank(a) - rank(b) || a.localeCompare(b));
    // Within each style group, list cards in the same category order as the
    // tabs, with 15 oz mugs before 12 oz mugs. Array sort is stable, so the
    // rest keep their admin order.
    const mugSize = item => item.dataset.catalogType === 'mug' && /\b12\s*oz\b/i.test(item.dataset.sampleName || '') ? 1 : 0;
    catalog.querySelectorAll('[data-catalog-group] ul').forEach(list => {
      list.append(...[...list.children].sort((a, b) =>
        rank(a.dataset.catalogType) - rank(b.dataset.catalogType) || mugSize(a) - mugSize(b)));
    });
    catalog.insertAdjacentHTML('afterbegin', `<div class="in-store-ipad__catalog-tabs" role="group" aria-label="Product categories">${['', ...sorted].map(type =>
      `<button type="button" data-action="catalog-filter" data-catalog-filter="${esc(type)}" aria-pressed="false">${esc(type ? labels[type] || type : 'All')}</button>`).join('')}</div>`);
    if (!types.has(catalogType)) catalogType = '';
    filterCatalog(catalogType);
  }

  function filterCatalog(type) {
    catalogType = type;
    const catalog = content.querySelector('[data-catalog]');
    if (!catalog) return;
    catalog.querySelectorAll('[data-catalog-type]').forEach(item => {
      item.hidden = Boolean(type && item.dataset.catalogType !== type);
    });
    catalog.querySelectorAll('[data-catalog-group]').forEach(group => {
      group.hidden = !group.querySelector('[data-catalog-type]:not([hidden])');
    });
    catalog.querySelectorAll('[data-catalog-filter]').forEach(tab => {
      tab.setAttribute('aria-pressed', String(tab.dataset.catalogFilter === type));
    });
  }

  function renderCartCount(count) {
    const total=Number(count || 0);
    cartButton.hidden=false;
    cartButton.innerHTML=cartIcon+'<span>'+total+'</span>';
    cartButton.setAttribute('aria-label',`Cart, ${total} items`);
  }
  async function refreshCartButton() {
    const epoch = orderEpoch;
    try {
      const response = await fetch('/cart.js', { cache: 'no-store' });
      if (!response.ok) return;
      const cart = await response.json();
      if (epoch !== orderEpoch || !session) return;
      renderCartCount(cart.item_count);
    } catch { /* The catalog can still be used if the cart count is unavailable. */ }
  }

  function productPagePath(href) {
    const url = new URL(href, location.origin);
    if (url.origin !== location.origin || !url.pathname.startsWith('/products/')) return null;
    url.searchParams.set('popup', '1');
    return themePath(url.pathname + url.search);
  }
  // Starts or joins the download of a product page. A touch on a catalog card
  // starts it before the tap completes, so the page is usually here already.
  function loadProductPage(path) {
    if (productPages.has(path)) return Promise.resolve(productPages.get(path));
    if (!productPageRequests.has(path)) {
      productPageRequests.set(path, fetch(path).then(async response => {
        if (!response.ok) throw new Error('Could not open this product.');
        const markup = await response.text();
        if (productPages.size >= 6) productPages.delete(productPages.keys().next().value);
        productPages.set(path, markup);
        return markup;
      }).finally(() => productPageRequests.delete(path)));
    }
    return productPageRequests.get(path);
  }
  function catalogProductLink(target) {
    const card = target?.closest?.('[data-catalog] product-card');
    if (!card || target.closest('button, input, label, select, [tabindex="1"]')) return null;
    return target.closest('a[href*="/products/"]') || card.querySelector('.product-card__link[href*="/products/"]');
  }

  async function chooseProduct(href) {
    if (busy || !session) return;
    const epoch = orderEpoch;
    busy = true;
    stopPolling();
    const link = [...content.querySelectorAll('[data-catalog] a[href*="/products/"]')]
      .find(item => item.href === href);
    if (link) link.setAttribute('aria-busy', 'true');
    try {
      const path = productPagePath(href);
      if (!path) throw new Error('Invalid product link.');
      // Tell the station about the product while its page loads, not after.
      // The card's id is checked against the loaded product below.
      const cardProductId = link?.closest('[data-product-id]')?.dataset.productId || '';
      let selecting = null;
      if (/^\d+$/.test(cardProductId)) {
        selecting = stationAction('select-product', { product_id: cardProductId });
        selecting.catch(() => {});
      }
      const markup = await loadProductPage(path);
      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const source = doc.querySelector('product-wizard');
      if (!source) throw new Error('This product does not have the required personalization options.');
      await customElements.whenDefined('product-wizard');
      if (epoch !== orderEpoch || !session) return;
      setIdentity();
      wizardHost.replaceChildren(document.importNode(source.closest('.wizard-section') || source, true));
      wizard = wizardHost.querySelector('product-wizard');
      if (!wizard?.productData?.previewRendered) throw new Error('This product is not ready for instant preview.');
      restoreDesignOptions();
      const productId = String(wizard.productData.id);
      if (selecting && cardProductId === productId) await selecting;
      else {
        // Let a mismatched early selection land first so it cannot overwrite this one.
        await selecting?.catch(() => {});
        await stationAction('select-product', { product_id: productId });
      }
      if (epoch !== orderEpoch || !session) return;
      restoreNativePhotos();
      adaptNativeWizard(doc);
      showOptions();
    } catch (error) {
      if (epoch !== orderEpoch || !session) return;
      try { await showCatalog(); content.insertAdjacentHTML('afterbegin', status(error.message, true)); }
      catch { content.innerHTML = `<h1>Could not load designs</h1>${status(error.message, true)}${actions(button('Try Again', 'catalog', true))}`; }
    } finally { link?.removeAttribute('aria-busy'); busy = false; }
  }

  function productImage() {
    const variantImage = wizard?.findMatchingVariant?.()?.featured_image?.src;
    if (variantImage) {
      const filename = variantImage.split('?')[0].split('/').pop();
      return wizard.productData.media?.find(media => media.src.split('?')[0].split('/').pop() === filename)?.src
        || variantImage;
    }
    return wizard?.galleryMainImg?.src || wizard?.productData?.media?.[0]?.src || '';
  }
  function price() {
    const variant = wizard?.findMatchingVariant?.();
    return variant ? wizard.formatMoney(variant.price) : '';
  }
  let photoDialog = null;
  function hideNativeWizard() {
    wizardHost.hidden = true;
    wizardHost.classList.remove('in-store-ipad__wizard-host--visible');
    wizardHost.setAttribute('aria-hidden', 'true');
    content.hidden = false;
  }
  function closePhotoModal() {
    stopPolling();
    photoDialog?.close();
  }
  function photoModalContent() {
    if (!photoDialog) {
      photoDialog = document.createElement('dialog');
      photoDialog.className = 'in-store-ipad__photo-modal';
      photoDialog.setAttribute('aria-label', 'Add Your Photos');
      photoDialog.innerHTML = '<button type="button" class="in-store-ipad__modal-close" data-action="close-photo-modal" aria-label="Close photos">×</button><div data-photo-modal-content></div>';
      photoDialog.addEventListener('cancel', event => {
        // A file picker also bubbles cancel when the same files are chosen.
        // Only an Escape/cancel directed at the dialog should dismiss it.
        if (event.target !== photoDialog) return;
        event.preventDefault(); closePhotoModal(); void closeHandoff();
      });
      root.append(photoDialog);
    }
    if (!photoDialog.open) photoDialog.showModal();
    return photoDialog.querySelector('[data-photo-modal-content]');
  }
  function restoreNativePhotos() {
    const choices = selections.slice();
    const count = choices.reduce((total, choice, index) => choice ? index + 1 : total, 0);
    while (wizard.multiPetActive && wizard.visiblePetCount < Math.min(count, wizard.getMaxPetGroups())) {
      wizard.revealNextPetGroup();
    }
    choices.forEach((choice, index) => {
      if (!choice) return;
      const photo = uploads.find(item => item.upload_id === choice.upload_id);
      if (photo && wizard.petGroups[index] && !wizard.petGroups[index].wrapper?.hidden) applyPhoto(index, photo, choice.name);
    });
  }

  function saveDesignOptions() {
    if (!session || !wizard) return;
    let saved;
    try { saved = JSON.parse(sessionStorage.getItem(designOptionsKey) || 'null'); } catch {}
    if (saved?.user_id !== session.user_id) saved = { user_id: session.user_id, products: {} };
    saved.products[String(wizard.productData.id)] = { ...wizard.selectedOptions };
    sessionStorage.setItem(designOptionsKey, JSON.stringify(saved));
  }

  function restoreDesignOptions() {
    try {
      const saved = JSON.parse(sessionStorage.getItem(designOptionsKey) || 'null');
      if (saved?.user_id !== session?.user_id) return;
      const options = saved.products?.[String(wizard.productData.id)];
      if (!options) return;
      const variant = wizard.productData.variants.find(item => wizard.productData.options.every((option, index) => item.options[index] === options[option.name]));
      if (!variant?.available) return;
      wizard.selectedOptions = { ...options };
      wizard.querySelectorAll('.wizard-swatch__input').forEach(input => { input.checked = options[input.name] === input.value; });
      wizard.updatePrice();
      wizard.scrollGalleryToVariant();
    } catch { /* Unavailable or outdated choices fall back to Shopify's current default. */ }
  }

  function syncNativeSelections() {
    if (!wizard || !session) return;
    saveDesignOptions();
    selections = wizard.petGroups.map(group => {
      const photo = wizard.uploads[group.fieldLabel];
      if (!photo?.upload_id) return null;
      const name = wizard.getPetNameInputForSlot(group.fieldLabel)?.value || '';
      photoNames.set(photo.upload_id, name);
      photo.pet_name = name;
      const prior = wizard.priorUploads?.find(item => item.upload_id === photo.upload_id);
      if (prior) prior.pet_name = name;
      wizard.querySelectorAll('[data-upload-tile]').forEach(tile => {
        if (tile.dataset.uploadId === photo.upload_id) tile.dataset.petName = name;
      });
      return { upload_id: photo.upload_id, name };
    });
    saveSelections();
  }
  function showNativeWizard(personalize = false, error = '') {
    if (!wizard) return;
    setScreen('product');
    closePhotoModal();
    content.hidden = true;
    wizardHost.hidden = false;
    wizardHost.classList.add('in-store-ipad__wizard-host--visible');
    wizardHost.setAttribute('aria-hidden', 'false');
    const step = personalize ? wizard.querySelector('[data-step-personalize]') : wizard.steps[0];
    if (step) wizard.currentStep = Number(step.dataset.step);
    wizard.updateUI();
    wizardHost.querySelector('[data-station-wizard-error]')?.remove();
    if (error) wizard.insertAdjacentHTML('afterbegin', '<p data-station-wizard-error role="alert">' + esc(error) + '</p>');
  }
  function adaptNativeWizard(doc) {
    wizard.configureInStorePreviewOptions?.();
    wizard.querySelectorAll('.wizard__guarantee,.wizard-trust-badges,.wizard-step__shipping-note,.wizard-nav__sticky-shipping,[data-quantity-hint]').forEach(el => el.remove());
    const details = [...doc.querySelectorAll('.product-info__item')].find(el => el.querySelector('summary')?.textContent.trim() === 'Product Details');
    if (details) {
      const copy = document.importNode(details, true);
      copy.querySelectorAll('.product-info__cta').forEach(el => el.remove());
      copy.classList.add('in-store-ipad__product-details');
      wizard.append(copy);
    }
    wizard.querySelectorAll('[data-upload-dropzone]').forEach(zone => {
      // The original carousel binds only when its hidden file input exists.
      // Preserve that control and its listeners while replacing the visible UI.
      const input = zone.querySelector('[data-upload-input]');
      zone.innerHTML = '<button type="button" class="in-store-ipad__button in-store-ipad__button--primary" data-station-add-photos>Add Your Photos</button>';
      if (input) { input.hidden = true; zone.append(input); }
    });
    wizard.addEventListener('click', event => {
      const upload = event.target.closest('[data-upload-dropzone],[data-upload-tile-plus],[data-upload-input],[data-photo-guide-toggle]');
      if (upload) {
        event.preventDefault(); event.stopImmediatePropagation();
        const zone = upload.closest('[data-upload]');
        slot = Math.max(0, wizard.petGroups.findIndex(group => group.zone === zone || group.fieldLabel === zone?.dataset.fieldLabel));
        void showHandoff();
        return;
      }
      if (event.target.closest('[data-preview-btn]')) {
        event.preventDefault(); event.stopImmediatePropagation(); void openPreview(); return;
      }
      if (event.target.closest('[data-add-to-cart]')) {
        event.preventDefault(); event.stopImmediatePropagation(); void addToCart(); return;
      }
      if (event.target.closest('[data-upload-tile],[data-remove-pet]')) queueMicrotask(syncNativeSelections);
    }, true);
    wizard.addEventListener('input', syncNativeSelections);
    wizard.addEventListener('change', syncNativeSelections);
  }

  function showOptions(error = '') {
    showNativeWizard(false, error);
  }

  async function showHandoff() {
    if (!session || !wizard) return;
    if (phoneMode) return showPhoneUpload();
    const epoch = orderEpoch;
    stopPolling();
    try {
      await stationAction('open-handoff');
      if (epoch !== orderEpoch) return;
      handoffOpen = true;
      lastTouchAt = Date.now();
    } catch (error) {
      if (epoch !== orderEpoch) return;
      const photoContent = photoModalContent();
      photoContent.innerHTML = `<h1>Could not open photo upload</h1>${status(error.message, true)}
        ${actions(button('Try Again', 'change-photo', true), button('Back to Product', 'options'))}`;
      return;
    }
    const photoContent = photoModalContent();
    photoContent.innerHTML = `<div class="in-store-ipad__grid in-store-ipad__grid--handoff"><div>
      <div class="in-store-ipad__eyebrow">Pet photo</div><h1>Everyday pet photos are fine</h1>
      <p>Choose a photo where we can see your pet's face.</p>
      <div data-photo-examples><div class="in-store-ipad__examples" aria-label="Everyday pet photo examples"><figure class="in-store-ipad__example"><img class="in-store-ipad__image" src="${esc(root.dataset.exampleUrl)}" alt="Example everyday pet photo"><figcaption>Everyday pet photo</figcaption></figure><figure class="in-store-ipad__example"><img class="in-store-ipad__image" src="${esc(root.dataset.welcomePetUrl)}" alt="Another example pet photo"><figcaption>Another everyday example</figcaption></figure></div><div class="in-store-ipad__example-nav">${button("Previous Example", "example-prev")}${button("Next Example", "example-next")}</div></div>
      </div><div class="in-store-ipad__handoff-right"><h2>Send pet photos from your phone</h2>
      <p>You can send more than one.</p>
      <div class="in-store-ipad__handoff"><div class="in-store-ipad__handoff-card">
        <img class="in-store-ipad__tap-photo" src="${esc(root.dataset.tapPhotoUrl)}" alt="Top of a face-up phone touching the NFC sticker beside the iPad">
        <strong>Tap phone here <span aria-hidden="true">→</span></strong>
      </div><div class="in-store-ipad__handoff-card">
        <strong>Or scan this QR code</strong>
        <img class="in-store-ipad__qr" src="${esc(root.dataset.qrUrl)}" alt="QR code to send a pet photo">
      </div></div>
      <details class="in-store-ipad__help"><summary>How does this work?</summary>
        <p>Tap the sticker or scan the code. On your phone:</p>
        <div class="in-store-ipad__help-screens">
          <figure><img src="${esc(root.dataset.phoneChooseUrl)}" alt="Phone page with Choose Photos button" width="195" height="422"><figcaption>1. Choose Photos</figcaption></figure>
          <figure><img src="${esc(root.dataset.phoneSendUrl)}" alt="Phone page with selected pet photo and Send button" width="195" height="422"><figcaption>2. Tap Send</figcaption></figure>
        </div>
        <p>Then finish on this iPad.</p></details>
      <div data-handoff-status></div>
      ${actions(button('Back to Product', 'options'))}</div></div>`;
    polling = setInterval(pollStation, 1800);
    await pollStation();
  }

  function showPhoneUpload(error = '') {
    phoneThumbUrls.forEach(url => URL.revokeObjectURL(url));
    phoneThumbUrls = [];
    phoneSelectedFiles = [];
    const photoContent = photoModalContent();
    photoContent.innerHTML = `<div class="in-store-ipad__grid in-store-ipad__grid--review"><div>
      <div class="in-store-ipad__eyebrow">Pet photo</div><h1>Everyday pet photos are fine</h1>
      <p>Choose a photo where we can see your pet's face.</p>
      <div data-photo-examples><div class="in-store-ipad__examples" aria-label="Everyday pet photo examples"><figure class="in-store-ipad__example"><img class="in-store-ipad__image" src="${esc(root.dataset.exampleUrl)}" alt="Example pet photo"><figcaption>Everyday pet photo</figcaption></figure><figure class="in-store-ipad__example"><img class="in-store-ipad__image" src="${esc(root.dataset.welcomePetUrl)}" alt="Another example pet photo"><figcaption>Another everyday example</figcaption></figure></div><div class="in-store-ipad__example-nav">${button("Previous Example", "example-prev")}${button("Next Example", "example-next")}</div></div>
      </div><div class="in-store-ipad__phone-upload"><h2>Choose Photos</h2>
      <p>Choose one or a few. You'll pick the photo for each design.</p>
      <div class="in-store-ipad__phone-thumbs" data-phone-thumbs></div>
      ${error ? status(error, true) : ''}</div></div>
      <div class="in-store-ipad__upload-actions">
      <div class="in-store-ipad__phone-picker">
        <span aria-hidden="true">Choose Photos</span>
        <input type="file" accept="image/*,.heic,.heif" multiple data-phone-files aria-label="Choose photos">
      </div>
      ${uploads.length ? actions(button('Use an Earlier Photo', 'saved-photos')) : ''}
      ${actions(button('Back to Product', 'options'), button('Use Photos', 'phone-upload', true))}</div>`;
    const send = photoContent.querySelector('[data-action="phone-upload"]');
    if (send) send.disabled = true;
  }

  async function sendPhonePhotos() {
    if (busy || !session || !wizard) return;
    const files = [...phoneSelectedFiles];
    if (!files.length || files.length > 4 || uploads.length + files.length > 8) {
      return showPhoneUpload('Choose up to four photos at once, and eight per order.');
    }
    const send = photoDialog?.querySelector('[data-action="phone-upload"]');
    busy = true;
    if (send) { send.disabled = true; send.textContent = 'Uploading…'; }
    const newPhotos = [];
    try {
      for (const file of files) {
        const result = await window.InstaMePhotoUpload.processAndUpload(file, {
          userId: session.user_id,
          backendUrl: api,
          extraFields: { group_id: crypto.randomUUID(), product_id: String(wizard.productData.id) },
        });
        newPhotos.push({ upload_id: result.upload_id, photo_url: result.photo_url,
          photo_path: result.photo_path, pet_name: '' });
      }
      uploads.push(...newPhotos);
      savePhoneUploads();
      const existing = selections[slot];
      const selected = uploads.find(photo => photo.upload_id === existing?.upload_id) || newPhotos[0];
      const name = existing?.name || photoNames.get(selected.upload_id) || '';
      selections[slot] = { upload_id: selected.upload_id, name };
      saveSelections();
      applyPhoto(slot, selected, name);
      renderSavedPets();
      showReview();
      wizard.petGroups[slot]?.zone?.scrollIntoView?.({ block: 'center', behavior: 'smooth' });
    } catch (error) {
      if (newPhotos.length) {
        uploads.push(...newPhotos);
        savePhoneUploads();
      }
      showPhoneUpload(error.userMessage || error.message || 'Could not upload those photos. Try again.');
    } finally { busy = false; }
  }

  function stopPolling() {
    pollGeneration++;
    if (polling) clearInterval(polling);
    polling = null;
  }
  async function closeHandoff() {
    if (phoneMode) return;
    if (!handoffOpen || !session) return;
    const epoch = orderEpoch;
    await stationAction('close-handoff');
    if (epoch === orderEpoch) handoffOpen = false;
  }
  async function pollStation() {
    if (!session || !wizard || busy || pollInFlight) return;
    const epoch = orderEpoch;
    const generation = pollGeneration;
    pollInFlight = true;
    try {
      const elapsed = Date.now() - lastTouchAt;
      if (elapsed >= handoffHeartbeatMs) {
        await stationAction('touch');
        if (epoch !== orderEpoch || generation !== pollGeneration) return;
        lastTouchAt = Date.now();
      }
      const snapshot = await stationRequest('GET');
      if (epoch !== orderEpoch || generation !== pollGeneration) return;
      if (!snapshot.active || snapshot.session_id !== session.session_id) {
        stopPolling();
        closePhotoModal();
        showReconnect('Reconnect to continue this order.');
        return;
      }
      const known = new Set(uploads.map(item => item.upload_id));
      const nextUploads = snapshot.uploads || [];
      if (snapshot.uploads_in_progress) {
        const box = root.querySelector('[data-handoff-status]');
        if (box) box.innerHTML = status('Receiving photos…');
        return;
      }
      const incoming = nextUploads.find(item => !known.has(item.upload_id));
      if (incoming) {
        await closeHandoff();
        if (epoch !== orderEpoch || generation !== pollGeneration) return;
        stopPolling();
        uploads = [...uploads, ...nextUploads.filter(item => !known.has(item.upload_id))];
        const selected = uploads.find(photo => photo.upload_id === selections[slot]?.upload_id) || incoming;
        const choice = { upload_id: selected.upload_id, name: selections[slot]?.name || photoNames.get(selected.upload_id) || selected.pet_name || '' };
        selections[slot] = choice;
        saveSelections();
        applyPhoto(slot, selected, choice.name);
        showReview();
      } else {
        // No new photos: leave the visible UI and saved selection untouched.
      }
    } catch (error) {
      if (epoch !== orderEpoch || generation !== pollGeneration) return;
      if (error.status === 409) return showStationInUse();
      const box = root.querySelector('[data-handoff-status]');
      if (box) box.innerHTML = status('Connection lost. Waiting to reconnect…', true);
    } finally { pollInFlight = false; }
  }

  function applyPhoto(index, photo, name = '') {
    const group = wizard?.petGroups?.[index];
    if (!group) return;
    const label = group.fieldLabel;
    wizard.uploads[label] = {
      upload_id: photo.upload_id,
      photo_url: photo.photo_url,
      photo_path: photo.photo_path,
      pet_name: name,
      uploading: false,
      selectSeq: (wizard.uploads[label]?.selectSeq || 0) + 1,
    };
    const input = wizard.getPetNameInputForSlot(label);
    if (input) input.value = name;
    wizard.priorUploads = uploads.map(item => ({ ...item, pet_name: photoNames.get(item.upload_id) || item.pet_name || '' }));
    wizard.querySelectorAll('[data-upload]').forEach(zone => {
      if (zone.dataset.uploadMode === 'carousel') wizard.renderCarousel(zone);
      else wizard.activateCarousel(zone);
      wizard.updateTileSelection(zone, wizard.uploads[zone.dataset.fieldLabel]?.upload_id);
    });
    wizard.updateTileSelection?.(group.zone, photo.upload_id);
    wizard.previewId = null;
    wizard.previewImageUrl = null;
    wizard.approvedPrintSignature = null;
    wizard.updatePreviewButtonState?.();
    wizard.updateBoothApprovalState?.();
    wizard.refreshMultiPetUI?.();
  }

  function showReview(error = '') {
    showNativeWizard(true, error);
  }

  async function openPreview() {
    const previewWizard = wizard;
    const epoch = orderEpoch;
    if (!previewWizard || !session) return;
    const fields = [...previewWizard.querySelectorAll('[data-line-item-property]')]
      .filter(input => !previewWizard.isSlotHidden(input));
    const missing = fields.find(input => input.required && !input.value.trim());
    if (missing) {
      showNativeWizard(true, `Enter ${missing.dataset.lineItemProperty} to continue.`);
      missing.focus();
      return;
    }
    if (!previewWizard.instantPreview) {
      content.insertAdjacentHTML('beforeend', status('Preview is still loading. Try again in a moment.', true));
      return;
    }
    const previewButton = content.querySelector('[data-action="preview"]');
    if (previewButton) { previewButton.disabled = true; previewButton.textContent = 'Opening preview…'; }
    try {
      previewWizard.instantPreview.ensurePopup();
      await previewWizard.instantPreview.openPreview();
      if (epoch === orderEpoch && wizard === previewWizard) previewWizard.instantPreview.popup?.querySelector('[data-preview-accept-label]')?.replaceChildren(document.createTextNode('Add to Cart'));
    }
    finally {
      if (epoch === orderEpoch && wizard === previewWizard && previewButton?.isConnected) {
        previewButton.disabled = false;
        previewButton.textContent = 'Instant Preview';
      }
    }
  }

  window.addEventListener('instame:in-store-preview-approved', event => {
    if (event.detail?.wizard === wizard && session && wizard.previewApproved?.() &&
        wizard.previewId && wizard.previewImageUrl) {
      addToCart();
    }
  });

  async function addToCart() {
    if (busy || !wizard?.previewApproved?.()) return;
    busy = true;
    const addButton = content.querySelector('[data-action="add-cart"]');
    if (addButton) { addButton.disabled = true; addButton.textContent = 'Adding to Cart…'; }
    try {
      const variant = wizard.findMatchingVariant();
      if (!variant?.available) {
        showOptions('This option is no longer available. Choose another option.');
        return;
      }
      const preview = wizard.instantPreview;
      const orderedVariant = preview?.getPreviewVariant?.() || variant;
      if (preview && wizard.approvedVariantId && String(wizard.approvedVariantId) !== String(orderedVariant.id)) {
        const saved = await preview.acceptPreview({ addToCart: false });
        if (!saved || String(wizard.approvedVariantId) !== String(orderedVariant.id)) throw new Error('Save the selected option before adding to cart.');
      }
      const added = await wizard.addToCart();
      if (!added?.id) {
        const cartError = wizard.querySelector('.wizard__cart-error')?.textContent?.trim();
        throw new Error(cartError || 'Could not add this design to the cart. Check the options and try again.');
      }
      await showCart();
      wizard.instantPreview?.closePopup();
    }
    catch (error) {
      wizard.instantPreview?.closePopup();
      showNativeWizard(true, error.message);
    }
    finally {
      if (addButton?.isConnected) { addButton.disabled = false; addButton.textContent = 'Add to Cart'; }
      busy = false;
    }
  }

  async function showCart() {
    hideNativeWizard();
    const response = await fetch('/cart.js', { cache: 'no-store' });
    if (!response.ok) throw new Error('Could not load your cart.');
    const cart = await response.json();
    renderCartCount(cart.item_count);
    setScreen('cart');
    const money = amount => new Intl.NumberFormat('en-US', {
      style: 'currency', currency: cart.currency || 'USD',
    }).format(amount / 100);
    const lines = cart.items.map(item => {
      const names = Object.entries(item.properties || {})
        .filter(([key, value]) => /^Pet Name(?: \d+)?$/.test(key) && value)
        .map(([, value]) => value).join(', ');
      const preview = item.properties?._preview_image;
      const image = typeof preview === 'string' && /^https:\/\//.test(preview) ? preview : item.image;
      return `<div class="in-store-ipad__cart-line">
<button type="button" class="in-store-ipad__cart-image" data-action="enlarge-cart-image" data-image="${esc(image || '')}" data-title="${esc(item.product_title)}" aria-label="Enlarge ${esc(item.product_title)}"><img src="${esc(image || '')}" alt="Your personalized design" width="130" height="130"></button>
      <div><h2>${esc(item.product_title.replace(/ \(Booth\)$/i, ''))}</h2>
      ${shipOnlyProductIds.has(String(item.product_id)) ? '<span class="in-store-ipad__delivery-note">Ships to you</span>' : ''}
      <p>${esc(item.variant_title || '')}</p>
      <p>${esc(names)}</p><button type="button" class="in-store-ipad__remove" data-action="remove-line" data-line-key="${esc(item.key)}">Remove</button></div>
      <strong>${esc(money(item.final_line_price))}</strong></div>`;
    }).join('');
    content.innerHTML = `<div class="in-store-ipad__cart"><div class="in-store-ipad__eyebrow">Your order</div><h1>Review your items</h1>
      <div class="in-store-ipad__cart-lines">${lines || '<p>Your cart is empty.</p>'}</div>
      <div class="in-store-ipad__cart-footer"><p class="in-store-ipad__cart-total"><span>Items</span><strong>${esc(money(cart.total_price))}</strong></p>
      ${actions(button('Keep Shopping', 'catalog'), cart.items.length ? button('Review & Finish', 'checkout-contact', true) : '')}</div></div>`;
  }

  // Reuse Horizon's dialog component for focus, Escape and scroll handling.
  async function stationDialog(markup, label, variant = '') {
    await customElements.whenDefined('dialog-component');
    const component = document.createElement('dialog-component');
    component.innerHTML = `<dialog ref="dialog" class="dialog-modal in-store-ipad__dialog ${variant}" aria-label="${esc(label)}">${markup}</dialog>`;
    document.body.append(component);
    component.addEventListener('dialog:close', () => component.remove(), { once: true });
    component.showDialog();
    return component;
  }

  let resetDialogOpen = false;
  async function requestStartOver() {
    if (busy || resetDialogOpen) return;
    resetDialogOpen = true;
    const component = await stationDialog('<div class="in-store-ipad__eyebrow">A fresh start</div><h2>Start over?</h2><p>Your design, photos and cart will be cleared. Completed orders are kept.</p><div class="in-store-ipad__actions"><button type="button" class="in-store-ipad__button" data-cancel-reset>Cancel</button><button type="button" class="in-store-ipad__button in-store-ipad__button--primary" data-confirm-reset>Start Over</button></div>', 'Start over?', 'in-store-ipad__dialog--reset');
    component.addEventListener('dialog:close', () => { resetDialogOpen = false; }, { once: true });
    component.querySelector('[data-cancel-reset]').addEventListener('click', () => component.closeDialog());
    component.querySelector('[data-confirm-reset]').addEventListener('click', async () => {
      await component.closeDialog();
      await endOrder();
      if (phoneMode) await beginOrder();
    }, { once: true });
  }

  async function enlargeCartImage(target) {
    if (!/^https:\/\//.test(target.dataset.image || '')) return;
    const component = await stationDialog(`<button type="button" class="in-store-ipad__modal-close" data-close-image aria-label="Close image">×</button><img class="in-store-ipad__enlarged-image" src="${esc(target.dataset.image)}" alt="${esc(target.dataset.title || 'Your personalized design')}">`, 'Your personalized design');
    component.querySelector('[data-close-image]').addEventListener('click', () => component.closeDialog());
  }

  async function finishAtCounter(target) {
    if (busy || !session) return;
    if (contactRequired && !customerContact()) {
      return showCustomerDetails();
    }
    busy = true;
    target.disabled = true;
    target.textContent = 'Preparing Order…';
    try {
      const cartResponse = await fetch('/cart.js', { cache: 'no-store' });
      if (!cartResponse.ok) throw new Error('Could not read your items. Try again.');
      const cart = await cartResponse.json();
      if (!cart.items?.length) throw new Error('Choose a personalized product first.');
      const phoneToken = phoneMode ? sessionStorage.getItem(phoneTokenKey) : null;
      if (phoneMode && !phoneToken) return showSessionExpired();
      const response = await fetch(`${api}/api/in-store/order`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json',
          ...(phoneMode ? { Authorization: `Bearer ${phoneToken}` }
            : { 'X-InstaMe-Session': session.session_id, 'X-InstaMe-Station':stationNumber }) },
        body: JSON.stringify({ source: phoneMode ? 'phone' : 'ipad',
          ...(contactRequired ? { customer: customerContact() } : {}),
          items: cart.items.map(item => ({ variant_id: String(item.variant_id),
            quantity: item.quantity, properties: item.properties || {} })) }),
      });
      if (response.status === 401 || response.status === 403) return showSessionExpired();
      const result = await response.json().catch(() => null);
      if (!response.ok || result?.ready !== true || !result?.draft_name) {
        throw new Error(result?.error || 'Could not prepare this order. Ask our team for help.');
      }
      const draftName = result.draft_name;
      const customerName = customerContact()?.name || '';
      if (phoneMode) {
        sessionStorage.setItem(phoneReceiptKey, JSON.stringify({ session_id: session.session_id, draft_name: draftName, customer_name: customerName }));
        busy = false;
        showPhoneReceipt(draftName);
        return;
      }
      // On the iPad, keep the shopper's photos and previews so they can place
      // another order; only Start Over clears them. The next order needs a
      // fresh cart and a new session id, because the server returns the same
      // draft for every order sent from one session.
      const kept = !phoneMode && await continueAfterOrder();
      busy = false;
      if (!kept) await endOrder();
      const clean = kept || !session;
      cartButton.hidden = !phoneMode;
      resetButton.hidden = phoneMode || clean;
      setScreen(kept ? 'placed' : 'receipt');
      content.innerHTML = `<div class="in-store-ipad__counter-ready">
        <div class="in-store-ipad__eyebrow">Ready for the counter</div>
        ${counterIdentity(draftName, customerName)}
        <p>You can add grab-and-go gifts and choose what ships when you pay.</p>
        ${kept ? actions(button('Start Over', 'reset', true), button('Make Another Order', 'another-order'))
          : clean ? actions(button(phoneMode ? 'Create Another Order' : 'Start Over', 'reset', true)) : status(phoneMode
          ? 'The cart could not clear. Ask our team for help before starting another order.'
          : 'Ask our team to reset this iPad before the next customer.', true)}
      </div>`;

    } catch (error) {
      target.disabled = false;
      target.textContent = currentScreen === 'contact' ? 'Finish' : 'Review & Finish';
      content.querySelector('[data-order-error]')?.remove();
      content.insertAdjacentHTML('beforeend', `<div data-order-error>${status(error.message, true)}</div>`);
    } finally { busy = false; }
  }

  // Starts the next order for the same shopper: an empty cart and a new
  // session id that keeps their photos and approved previews. Returns false
  // if that could not be done, so the caller falls back to a full reset.
  async function continueAfterOrder() {
    const epoch = orderEpoch;
    try {
      await clearCart();
      const nextId = newStartSessionId();
      const next = await stationAction('next-order', { next_session_id: nextId });
      if (epoch !== orderEpoch || !next?.active || (!phoneMode && next.session_id !== nextId) ||
          next.user_id !== session?.user_id) return false;
      const contact = sessionStorage.getItem(contactKey);
      session = { ...session, ...next };
      setIdentity();
      if (contact) {
        try {
          const saved = JSON.parse(contact);
          sessionStorage.setItem(contactKey, JSON.stringify({ ...saved, session_id: session.session_id }));
        } catch { /* The shopper is asked for their details again. */ }
      }
      saveSelections();
      if (phoneMode) sessionStorage.removeItem(phoneReceiptKey);
      handoffOpen = false;
      lastTouchAt = Date.now();
      return true;
    } catch { return false; }
  }

  function completedPhoneOrder() {
    try {
      const receipt = JSON.parse(sessionStorage.getItem(phoneReceiptKey) || 'null');
      return receipt?.session_id === session?.session_id && typeof receipt.draft_name === 'string' ? receipt : null;
    } catch { return null; }
  }

  function counterIdentity(draftName, customerName = '') {
    return customerName ? `<h1>Give your name at the counter</h1>
      <div class="in-store-ipad__counter-name">${esc(customerName)}</div>
      <p class="in-store-ipad__counter-reference">Order ${esc(draftName)}</p>`
      : `<h1>Show this number to our team</h1><div class="in-store-ipad__counter-code">${esc(draftName)}</div>`;
  }

  function showPhoneReceipt(draftName, error = '') {
    hideNativeWizard();
    setScreen('receipt');
    cartButton.hidden = true;
    content.innerHTML = `<div class="in-store-ipad__counter-ready"><div class="in-store-ipad__eyebrow">Ready for the counter</div>
      ${counterIdentity(draftName, completedPhoneOrder()?.customer_name || customerContact()?.name || '')}
      <p>Your photos and designs are saved for your next order.</p>${error ? status(error, true) : ''}
      ${actions(button('Create Another Order', 'another-order', true))}</div>`;
  }

  async function makeAnotherOrder() {
    if (busy || !session) return;
    const receipt = phoneMode && completedPhoneOrder();
    if (receipt) {
      busy = true;
      const continued = await continueAfterOrder();
      busy = false;
      if (!continued) return showPhoneReceipt(receipt.draft_name, 'Could not open the next order. Your photos and designs are still saved. Try again.');
    }
    if (wizard) showNativeWizard(true);
    else void showCatalog();
  }

  async function removeCartLine(key) {
    if (busy || !key) return;
    busy = true;
    try {
      const response = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: 0 }),
      });
      if (!response.ok) throw new Error('Could not remove this item. Try again.');
      await showCart();
    } catch (error) { content.insertAdjacentHTML('beforeend', status(error.message, true)); }
    finally { busy = false; }
  }

  async function resume() {
    if (phoneMode) return resumePhone();
    const resetPending = localStorage.getItem(resetPendingKey);
    if (resetPending !== null) {
      session = resetPending === 'none' ? null : { session_id: resetPending };
      return endOrder();
    }
    const persistedSessionId = localStorage.getItem(deviceSessionKey);
    try {
      const snapshot = await stationRequest('GET');
      const pendingId = localStorage.getItem(startPendingKey);
      // A browser may reopen after the server session expires while Shopify
      // still has that shopper's cart cookie. Clear both before showing welcome.
      if (!snapshot.active) {
        if (!pendingId) return persistedSessionId ? showSessionExpired() : showWelcome();
        session = await stationAction('start', { start_session_id: pendingId });
      } else session = snapshot;
      localStorage.removeItem(startPendingKey);
      lastActivityAt = Date.now();
      localStorage.setItem(lastActivityKey, String(lastActivityAt));
      lastTouchAt = Date.now();
      uploads = snapshot.uploads || [];
      setIdentity();
      if (sessionStorage.getItem(checkoutKey)) return endOrder();
      restoreSelections();
      renderSavedPets();
      // A reload cannot restore the in-memory product wizard. Close its old
      // phone handoff so a later send cannot land on the catalog screen.
      handoffOpen = Boolean(snapshot.accepting_uploads);
      await showCatalog();
    } catch (error) {
      if (error.status === 409) showStationInUse();
      else if (session) showCatalogError(error);
      else if (localStorage.getItem(deviceSessionKey) || localStorage.getItem(startPendingKey)) showReconnect(error.message);
      else showWelcome(error.message);
    }
  }

  async function resumePhone() {
    document.title = 'Shop in Store | LilaLand';
    try {
      const saved = JSON.parse(sessionStorage.getItem(phoneSessionKey) || 'null');
      const token = sessionStorage.getItem(phoneTokenKey);
      if (!saved || !token || saved.expires_at <= Date.now()) {
        session = null;
        showWelcome();
        return;
      }
      session = { session_id: saved.session_id, user_id: saved.user_id };
      const storedPhotos = JSON.parse(sessionStorage.getItem(phoneUploadsKey) || '[]');
      uploads = Array.isArray(storedPhotos) ? storedPhotos : [];
      setIdentity();
      restoreSelections();
      renderSavedPets();
      resetButton.hidden = false;
      const receipt = completedPhoneOrder();
      if (receipt) return showPhoneReceipt(receipt.draft_name);
      await showCatalog();
      await openRequestedScreen();
    } catch (error) {
      session = null;
      showWelcome(error.message);
    }
  }

  root.addEventListener('click', async event => {
    const phoneFileInput = event.target.closest('[data-phone-files]');
    if (phoneFileInput && !busy) phoneFileInput.value = '';
    const productLink = catalogProductLink(event.target);
    if (productLink) {
      event.preventDefault();
      event.stopPropagation();
      await chooseProduct(productLink.href);
      return;
    }
    const target = event.target.closest('[data-action]');
    if (!target) return;
    const action = target.dataset.action;
    if(action==='example-prev' || action==='example-next') {
      const examples=target.closest('[data-photo-examples]')?.querySelector('.in-store-ipad__examples');
      examples?.scrollBy({left:(examples.clientWidth+16)*(action==='example-next'?1:-1),behavior:'smooth'});
    }
    else if (action === 'enlarge-cart-image') await enlargeCartImage(target);
    else if (action === 'close-photo-modal') { closePhotoModal(); await closeHandoff(); }
    else if (action === 'start') await beginOrder();
    else if (action === 'customer-continue') await saveCustomerDetails();
    else if (action === 'retry-station') await resume();
    else if (action === 'recover-station') await recoverAbandoned();
    else if (action === 'restart-station' && contactRequired) {
      content.innerHTML = `<div class="in-store-ipad__staff"><h1>Start a new order here?</h1>
        <p>This ends the order open in the other browser. Completed Shopify drafts are kept.</p>
        ${actions(button('Start New Order Here', 'confirm-restart-station', true), button('Cancel', 'cancel-restart-station'))}</div>`;
    }
    else if (action === 'confirm-restart-station' && contactRequired) await recoverAbandoned(true);
    else if (action === 'cancel-restart-station') showStationInUse();
    else if (action === 'catalog') {
      try { await showCatalog(); }
      catch (error) { showCatalogError(error); }
    }
    else if (action === 'options') {
      stopPolling();
      try {
        await closeHandoff();
        if (photoDialog?.open) showNativeWizard(true);
        else showOptions();
      }
      catch {
        const box = root.querySelector('[data-handoff-status]');
        if (box) {
          box.innerHTML = status('Connection lost. Try Back to Product again.', true);
          polling = setInterval(pollStation, 1800);
        } else content.insertAdjacentHTML('beforeend', status('Connection lost. Try Back to Product again.', true));
      }
    }
    else if (action === 'edit-design') showOptions();
    else if (action === 'edit-photo') { slot = 0; showReview(); }
    else if (action === 'edit-name') { slot = 0; showReview(); }
    else if (action === 'catalog-filter') filterCatalog(target.dataset.catalogFilter);
    else if (action === 'change-photo') await showHandoff();
    else if (action === 'saved-photos') { closePhotoModal(); await closeHandoff(); showNativeWizard(true); }
    else if (action === 'phone-upload') await sendPhonePhotos();
    else if (action === 'remove-phone-photo' && !busy) {
      const index = Number(target.dataset.photoIndex);
      if (Number.isInteger(index) && index >= 0 && index < phoneSelectedFiles.length) {
        URL.revokeObjectURL(phoneThumbUrls[index]);
        phoneThumbUrls.splice(index, 1);
        phoneSelectedFiles.splice(index, 1);
        renderPhoneSelection();
      }
    }
    else if (action === 'add-pet') {
      wizard.revealNextPetGroup();
      slot = wizard.visiblePetCount - 1;
      showNativeWizard(true);
    } else if (action === 'remove-pet') {
      wizard.removePetGroup(slot);
      selections.splice(slot, 1);
      saveSelections();
      slot = Math.min(slot, wizard.visiblePetCount - 1);
      showReview();
    }
    else if (action === 'review') showReview();
    else if (action === 'review-previous') {
      slot = Math.max(0, slot - 1);
      if (selections[slot]?.upload_id) showReview();
      else showNativeWizard(true);
    }
    else if (action === 'review-next') await openPreview();
    else if (action === 'select-photo') {
      const photo = uploads.find(item => item.upload_id === target.dataset.uploadId);
      if (photo && !selections.some((selected, index) => index !== slot && selected?.upload_id === photo.upload_id)) {
        selections[slot] = { upload_id: photo.upload_id, name: photoNames.get(photo.upload_id) || photo.pet_name || '' };
        saveSelections();
        applyPhoto(slot, photo, selections[slot].name);
        showReview();
      }
    } else if (action === 'preview') await openPreview();
    else if (action === 'add-cart') await addToCart();
    else if (action === 'remove-line') await removeCartLine(target.dataset.lineKey);
    else if (action === 'checkout-contact') { if (contactRequired) showCustomerDetails(); else await finishAtCounter(target); }
    else if (action === 'finish') await finishAtCounter(target);
    else if (action === 'another-order') await makeAnotherOrder();
    else if (action === 'reset') await requestStartOver();
  }, true);

  // Start downloading a product page as soon as its card is touched. Only the
  // download starts here; the station is not told until the tap completes.
  root.addEventListener('pointerdown', event => {
    if (busy || !session) return;
    try {
      const link = catalogProductLink(event.target);
      const path = link && productPagePath(link.href);
      if (path) loadProductPage(path).catch(() => {});
    } catch { /* The tap itself still opens the product. */ }
  }, { passive: true });
  root.addEventListener('change', event => {
    if (!phoneMode || busy || !event.target.matches('[data-phone-files]')) return;
    const files = [...(event.target.files || [])].filter(file => !phoneSelectedFiles.some(old =>
      old.name === file.name && old.size === file.size && old.lastModified === file.lastModified));
    const thumbs = photoDialog?.querySelector('[data-phone-thumbs]');
    const send = photoDialog?.querySelector('[data-action="phone-upload"]');
    if (!thumbs || !send) return;
    if (phoneSelectedFiles.length + files.length > 4 || uploads.length + phoneSelectedFiles.length + files.length > 8) {
      send.insertAdjacentHTML('beforebegin', status('Choose up to four at once, and eight per order.', true));
      return;
    }
    phoneThumbUrls.push(...files.map(file => URL.createObjectURL(file)));
    phoneSelectedFiles.push(...files);
    event.target.value = '';
    renderPhoneSelection();
    if (files.length) thumbs.scrollIntoView({ block: 'start', behavior: 'smooth' });
  });

  function renderPhoneSelection() {
    const thumbs = photoDialog?.querySelector('[data-phone-thumbs]');
    const send = photoDialog?.querySelector('[data-action="phone-upload"]');
    if (!thumbs || !send) return;
    thumbs.innerHTML = phoneThumbUrls.map((url, index) =>
      `<figure><img src="${esc(url)}" alt="Selected pet photo ${index + 1}"><button type="button" data-action="remove-phone-photo" data-photo-index="${index}">Remove photo</button></figure>`).join('');
    send.disabled = !phoneSelectedFiles.length;
  }

  // The Instant Preview popup is attached to document.body, outside root.
  function markActivity() {
    lastActivityAt = Date.now();
    if (session && !recoveryScreen) {
      localStorage.setItem(lastActivityKey, String(lastActivityAt));
    }
  }
  document.addEventListener('pointerdown', markActivity, { passive: true });
  document.addEventListener('keydown', markActivity);
  function checkIdle() {
    if (phoneMode) return;
    if (!session || busy) return;
    const now = Date.now();

    if (now - lastTouchAt < 5 * 60 * 1000) return;
    lastTouchAt = now;
    const epoch = orderEpoch;
    stationAction('touch').catch(error => {
      if (epoch === orderEpoch && error.status === 409) showReconnect('This order needs to reconnect. Your saved order has not been cleared.');
    });
  }
  setInterval(checkIdle, 60000);
  document.addEventListener('visibilitychange', () => {
    if (!document.hidden) checkIdle();
  });
  resetButton.addEventListener('click', requestStartOver);
  // The logo does exactly what Shop All does.
  const shopAll = () => { if (!busy) void beginOrder(); };
  root.querySelector('[data-station-shop]')?.addEventListener('click', shopAll);
  root.querySelector('[data-station-home]')?.addEventListener('click', shopAll);
  root.querySelector('[data-station-back]')?.addEventListener('click', () => {
    if (busy) return;
    if (photoDialog?.open) { closePhotoModal(); void closeHandoff(); }
    else if(currentScreen === 'contact') {
      contactDraft = {name:content.querySelector('[data-customer-name]')?.value || '',phone:content.querySelector('[data-customer-phone]')?.value || '',marketing:content.querySelector('[data-customer-marketing]')?.checked !== false};
      void showCart();
    }
    else if(currentScreen === 'catalog') showWelcome();
    else if(currentScreen === 'welcome' || currentScreen === 'receipt')return;
    else if(currentScreen === 'placed')makeAnotherOrder();
    else if(currentScreen === 'cart' && wizard)showNativeWizard(true);
    else if (wizardHost.classList.contains('in-store-ipad__wizard-host--visible') && wizard?.currentStep > 1) wizard.prevStep();
    else if (session) void showCatalog();
    else showWelcome();
  });
  savedPets?.addEventListener?.('click', () => {
    if (!uploads.length || busy) return;
    const panel = photoModalContent();
    panel.innerHTML = '<h2>Your Pet Photos</h2><div class="in-store-ipad__photo-choices">' + uploads.map(photo => '<figure><img src="' + esc(photo.photo_url) + '" alt="Your pet photo"><figcaption>' + esc(photoNames.get(photo.upload_id) || photo.pet_name || '') + '</figcaption></figure>').join('') + '</div>';
  });
  cartButton.addEventListener('click', async () => {
    if(busy)return;
    if(phoneMode && completedPhoneOrder())return makeAnotherOrder();
    if(!session){if(phoneMode){pendingCart=true;void beginOrder();}return;}
    try { stopPolling(); await closeHandoff(); await showCart(); }
    catch (error) { content.insertAdjacentHTML('beforeend', status(error.message, true)); }
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted && sessionStorage.getItem(checkoutKey)) endOrder();
    else if (event.persisted) checkIdle();
  });
  async function openRequestedScreen() {
    if(pendingProduct && session) {
      const product=pendingProduct;pendingProduct=null;await chooseProduct(product);
    } else if(pendingCart && session) {
      pendingCart=false;await showCart();
    }
  }
  resume();
})();
